interface TeamData {
  team?: {
    teamId: string;
    teamName: string;
  };
}

export const formatUserTeams = (teams: TeamData[] | TeamData) => {
  const list = Array.isArray(teams) ? teams : [teams].filter(Boolean);

  const fullTeamList = list
    .filter(({ team }) => team?.teamId && team?.teamName)
    .map(({ team }) => ({
      key: team!.teamId,
      label: team!.teamName,
      value: team!.teamName,
    }));

  const teamNames = list.filter(({ team }) => team?.teamName).map(({ team }) => team!.teamName);
  const teamIds = list.filter(({ team }) => team?.teamId).map(({ team }) => team!.teamId);

  return { fullTeamList, teamNames, teamIds };
};
